type PhoneSize = 'large' | 'medium' | 'small';

type AzaleaPhoneMockupProps = {
  src: string;
  alt: string;
  size?: PhoneSize;
  loading?: 'eager' | 'lazy';
  className?: string;
};

export function AzaleaPhoneMockup({
  src,
  alt,
  size = 'medium',
  loading = 'lazy',
  className = '',
}: AzaleaPhoneMockupProps) {
  return (
    <div className={`azalea-iphone azalea-iphone--${size} ${className}`.trim()}>
      <div className="azalea-iphone-bezel">
        <div className="azalea-iphone-island" aria-hidden="true" />
        <div className="azalea-iphone-screen">
          <img src={src} alt={alt} loading={loading} />
        </div>
        <div className="azalea-iphone-home" aria-hidden="true" />
      </div>
    </div>
  );
}
